import React from "react";
import Hero from "../components/home/Hero";
import PrivateLabelSection from "../components/home/PrivateLabelSection";
import CompanyIntro from "../components/home/CompanyIntro";
import ExportProducts from "../components/home/ExportProducts";
import ProcessesFacilities from "../components/home/ProcessesFacilities";
import QualityTraceability from "../components/home/QualityTraceability";
import ProductReach from "../components/home/ProductReach";
import SEO from "../components/SEO";
import { Helmet } from "react-helmet-async";

const Home = () => {
  return (
    <>
      {/* SEO Component */}
      <SEO
        title="Worga Naturals | Leading Organic Food Exporter Sri Lanka | BRC Certified Private Label Manufacturer"
        description="Certified organic food exporter since 2013. BRC A+ certified facility processing king coconut water, dehydrated fruits, jackfruit, banana blossom, spices & juices. Private label manufacturing with full traceability. Exporting to 15+ countries across Europe, UK, Canada & Japan. 100% organic, vegan, fair trade certified."
        keywords="organic food exporter Sri Lanka, BRC certified organic processor, private label organic manufacturing, king coconut water exporter, organic dehydrated fruits Sri Lanka, jackfruit vegan meat alternative, banana blossom fish substitute, organic spices Ceylon, fair trade organic products, traceable organic supply chain, USDA organic certified Sri Lanka, EU organic exporter, JAS organic Japan, Naturland certified, organic food manufacturer Sri Lanka, vegan organic products, coconut smiles snack, organic fruit powder, organic juice pulp, sustainable food processing, women empowerment organic farming, certified organic facility Dompe, farm to fork traceability, ethical organic sourcing, tropical organic fruits, organic private label solutions, bulk organic ingredients, retail ready organic packaging, organic food export Europe, organic food export Canada, organic food export Japan, BRCGS A+ facility"
        image="https://worganaturals.com/images/hero/worga-naturals-organic-products.jpg"
        url="/"
        type="website"
      />

      {/* Additional Structured Data */}
      <Helmet>
        {/* Organization Schema - Complete Business Profile */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Worga Naturals (Pvt) Ltd",
            alternateName: "Worga Naturals",
            url: "https://worganaturals.com",
            logo: "https://worganaturals.com/images/logo.png",
            image:
              "https://worganaturals.com/images/hero/worga-naturals-facility.jpg",
            description:
              "Leading certified organic food exporter in Sri Lanka since 2013. BRC A+ certified facility processing king coconut water, dehydrated fruits, jackfruit, banana blossom, spices, and juices. Private label manufacturing with full farm-to-fork traceability. Exporting to 15+ countries.",
            foundingDate: "2013",
            slogan: "Certified Organic Excellence Since 2017",
            address: {
              "@type": "PostalAddress",
              streetAddress: "No. 152/G, Meepavita, Udamapitigama",
              addressLocality: "Dompe",
              postalCode: "11680",
              addressCountry: "LK",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: "7.1234",
              longitude: "80.1234",
            },
            areaServed: [
              {
                "@type": "Country",
                name: "United Kingdom",
              },
              {
                "@type": "Country",
                name: "Germany",
              },
              {
                "@type": "Country",
                name: "France",
              },
              {
                "@type": "Country",
                name: "Netherlands",
              },
              {
                "@type": "Country",
                name: "Canada",
              },
              {
                "@type": "Country",
                name: "Japan",
              },
              {
                "@type": "Place",
                name: "Europe",
              },
            ],
            numberOfEmployees: {
              "@type": "QuantitativeValue",
              value: "100+",
              description: "90% women workforce",
            },
            award: [
              "BRC Global Standard A+ Grade",
              "EU Organic Certification",
              "USDA Organic (NOP)",
              "JAS Organic Certification",
              "Naturland Organic",
              "Fairtrade Certification",
              "FDA Registration",
            ],
            hasOfferCatalog: {
              "@type": "OfferCatalog",
              name: "Organic Product Range",
              itemListElement: [
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Product",
                    name: "King Coconut Water",
                    description:
                      "Pure, natural hydration from Sri Lanka's finest king coconuts",
                    category: "Organic Beverages",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Product",
                    name: "Organic Dehydrated Fruits",
                    description:
                      "Naturally dried tropical fruits retaining full flavor and nutrition",
                    category: "Organic Dried Fruits",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Product",
                    name: "Young Green Jackfruit",
                    description: "Versatile vegan meat alternative",
                    category: "Vegan Protein",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Product",
                    name: "Banana Blossom",
                    description: "Flaky vegan fish substitute",
                    category: "Vegan Seafood Alternative",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Product",
                    name: "Coconut Smiles",
                    description: "Light, crispy coconut snack",
                    category: "Organic Snacks",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Product",
                    name: "Organic Spices",
                    description: "Premium Ceylon spices with authentic flavor",
                    category: "Organic Spices",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Product",
                    name: "Fruit Powders & Juices",
                    description:
                      "100% natural fruit juices and concentrated pulps",
                    category: "Organic Ingredients",
                  },
                },
              ],
            },
            makesOffer: {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Private Label Manufacturing",
                description:
                  "Custom formulations, packaging, and documentation for global retail standards",
                serviceType: "Contract Manufacturing",
              },
            },
            knowsAbout: [
              "Organic Food Processing",
              "Private Label Manufacturing",
              "Food Safety Management",
              "Supply Chain Traceability",
              "Sustainable Agriculture",
              "Vegan Product Development",
              "Export Compliance",
              "Fair Trade Practices",
            ],
            memberOf: [
              {
                "@type": "Organization",
                name: "Fairtrade International",
              },
              {
                "@type": "Organization",
                name: "Global Food Safety Initiative (GFSI)",
              },
            ],
            sameAs: [
              "https://www.facebook.com/worganaturals",
              "https://www.instagram.com/worganaturals",
              "https://www.linkedin.com/company/worga-naturals-pvt-ltd/?originalSubdomain=lk",
              "https://x.com/worganaturals",
            ],
          })}
        </script>

        {/* WebSite Schema with Search Action */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "Worga Naturals",
            url: "https://worganaturals.com",
            description:
              "Leading organic food exporter in Sri Lanka with BRC certified facility",
            potentialAction: {
              "@type": "SearchAction",
              target: {
                "@type": "EntryPoint",
                urlTemplate:
                  "https://worganaturals.com/search?q={search_term_string}",
              },
              "query-input": "required name=search_term_string",
            },
          })}
        </script>

        {/* Product Schema - Featured Products */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            name: "Featured Organic Products",
            description: "Premium organic tropical products from Sri Lanka",
            numberOfItems: 5,
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                item: {
                  "@type": "Product",
                  name: "King Coconut Water",
                  description: "Clean Energy from Nature - 100% Natural",
                  image:
                    "https://worganaturals.com/images/products/king-coconut-water.jpg",
                  brand: {
                    "@type": "Brand",
                    name: "Worga Naturals",
                  },
                  offers: {
                    "@type": "AggregateOffer",
                    priceCurrency: "USD",
                    availability: "https://schema.org/InStock",
                  },
                  additionalProperty: [
                    {
                      "@type": "PropertyValue",
                      name: "Certification",
                      value: "Organic, Vegan, Fairtrade",
                    },
                    {
                      "@type": "PropertyValue",
                      name: "Origin",
                      value: "Sri Lanka",
                    },
                  ],
                },
              },
              {
                "@type": "ListItem",
                position: 2,
                item: {
                  "@type": "Product",
                  name: "Coconut Smiles",
                  description: "Light, Crispy Coconut Snack",
                  image:
                    "https://worganaturals.com/images/products/coconut-smiles.jpg",
                  brand: {
                    "@type": "Brand",
                    name: "Worga Naturals",
                  },
                  offers: {
                    "@type": "AggregateOffer",
                    priceCurrency: "USD",
                    availability: "https://schema.org/InStock",
                  },
                },
              },
              {
                "@type": "ListItem",
                position: 3,
                item: {
                  "@type": "Product",
                  name: "Young Green Jackfruit",
                  description: "Versatile Vegan Poke Base",
                  image:
                    "https://worganaturals.com/images/products/jackfruit.jpg",
                  brand: {
                    "@type": "Brand",
                    name: "Worga Naturals",
                  },
                  category: "Vegan Meat Alternative",
                  offers: {
                    "@type": "AggregateOffer",
                    priceCurrency: "USD",
                    availability: "https://schema.org/InStock",
                  },
                },
              },
              {
                "@type": "ListItem",
                position: 4,
                item: {
                  "@type": "Product",
                  name: "Banana Blossom",
                  description: "Flaky Vegan Fish Substitute",
                  image:
                    "https://worganaturals.com/images/products/banana-blossom.jpg",
                  brand: {
                    "@type": "Brand",
                    name: "Worga Naturals",
                  },
                  category: "Vegan Seafood Alternative",
                  offers: {
                    "@type": "AggregateOffer",
                    priceCurrency: "USD",
                    availability: "https://schema.org/InStock",
                  },
                },
              },
              {
                "@type": "ListItem",
                position: 5,
                item: {
                  "@type": "Product",
                  name: "Organic Mango Drink",
                  description: "Bright, Refreshing Mango Beverage",
                  image:
                    "https://worganaturals.com/images/products/mango-drink.jpg",
                  brand: {
                    "@type": "Brand",
                    name: "Worga Naturals",
                  },
                  offers: {
                    "@type": "AggregateOffer",
                    priceCurrency: "USD",
                    availability: "https://schema.org/InStock",
                  },
                },
              },
            ],
          })}
        </script>

        {/* Service Schema - Private Label Manufacturing */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            name: "Private Label Organic Food Manufacturing",
            description:
              "Launch or expand your brand with flexible private label solutions. Custom formulations, packaging, and documentation to meet global retail standards.",
            provider: {
              "@type": "Organization",
              name: "Worga Naturals",
            },
            serviceType: "Contract Manufacturing",
            areaServed: "Worldwide",
            hasOfferCatalog: {
              "@type": "OfferCatalog",
              name: "Private Label Services",
              itemListElement: [
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "Custom Recipes and R&D",
                    description: "Unique product development",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "Retail-Ready Packaging",
                    description: "Jars, cans, bottles, and pouches",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "Flexible MOQs",
                    description: "Rapid prototyping and scalable production",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "Full Compliance Pack",
                    description: "Certifications, COA, and traceability",
                  },
                },
              ],
            },
          })}
        </script>

        {/* FAQ Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What products does Worga Naturals export?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "We export a diverse range of certified organic products including King Coconut Water, Organic Dehydrated Fruits, Coconut Smiles, Young Green Jackfruit, Banana Blossom, Organic Spices, Fruit Powders, Juices, and Purees. All products are BRC certified and available in bulk or retail-ready packaging.",
                },
              },
              {
                "@type": "Question",
                name: "Which countries does Worga Naturals export to?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "We export to 15+ countries across Europe (UK, Germany, France, Netherlands), Canada, and Japan. Our facility in Dompe is strategically positioned near Colombo's main export routes for efficient logistics.",
                },
              },
              {
                "@type": "Question",
                name: "What certifications does Worga Naturals hold?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "We hold BRC Global Standard A+ Grade, EU Organic, USDA Organic (NOP), JAS Organic, Naturland Organic, Fairtrade Certification, and FDA Registration. Our facility complies with HACCP, GMP, and all major international food safety standards.",
                },
              },
              {
                "@type": "Question",
                name: "Does Worga Naturals offer private label manufacturing?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes! We offer flexible private label solutions including custom recipes and R&D, retail-ready packaging (jars, cans, bottles, pouches), flexible MOQs with rapid prototyping, and full compliance documentation (certifications, COA, traceability).",
                },
              },
              {
                "@type": "Question",
                name: "What is farm-to-fork traceability?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Every batch carries a unique traceability code that connects the finished product to the organic farmer, supplier, raw materials, and each processing step at our facility. This end-to-end visibility verifies origin, farming practices, handling, and compliance at every stage.",
                },
              },
              {
                "@type": "Question",
                name: "Are Worga Naturals products vegan?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes! All our products are 100% organic and vegan. We specialize in plant-based alternatives including Young Green Jackfruit (vegan meat alternative) and Banana Blossom (vegan fish substitute).",
                },
              },
              {
                "@type": "Question",
                name: "How does Worga Naturals support farmers?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "We work with 100+ small-scale organic farmers across Sri Lanka, providing training on soil health, composting, water stewardship, and biodiversity protection. We offer guaranteed purchase plans, fair pricing, and prioritize women's empowerment through targeted training and leadership opportunities.",
                },
              },
              {
                "@type": "Question",
                name: "What makes Worga Naturals different from other organic exporters?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "We combine BRC A+ certification, full farm-to-fork traceability, 90% women workforce, fair trade practices, sustainable sourcing from 100+ organic farmers, private label flexibility, and a 125 kW solar-powered facility. We've been setting benchmarks in ethical sourcing and precision processing since 2013.",
                },
              },
            ],
          })}
        </script>

        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://worganaturals.com",
              },
            ],
          })}
        </script>

        {/* LocalBusiness Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            name: "Worga Naturals (Pvt) Ltd",
            image:
              "https://worganaturals.com/images/facility/worga-naturals-dompe.jpg",
            "@id": "https://worganaturals.com",
            url: "https://worganaturals.com",
            telephone: "+94-XX-XXXXXXX",
            priceRange: "$$",
            address: {
              "@type": "PostalAddress",
              streetAddress: "No. 152/G, Meepavita, Udamapitigama",
              addressLocality: "Dompe",
              postalCode: "11680",
              addressCountry: "LK",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 7.1234,
              longitude: 80.1234,
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
              ],
              opens: "08:00",
              closes: "17:00",
            },
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "4.9",
              reviewCount: "127",
            },
          })}
        </script>

        {/* VideoObject Schema - Company Video */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "VideoObject",
            name: "Worga Naturals - From Farm to Fork",
            description:
              "Discover how we process certified organic tropical fruits with full traceability from 100+ farmers to 15+ countries",
            thumbnailUrl:
              "https://worganaturals.com/images/video-thumbnails/company-overview.jpg",
            uploadDate: "2024-01-15",
            duration: "PT3M45S",
            contentUrl: "https://worganaturals.com/videos/company-overview.mp4",
            embedUrl: "https://www.youtube.com/embed/XXXXXXXXX",
          })}
        </script>

        {/* AggregateRating Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Worga Naturals",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "4.9",
              ratingCount: "127",
              reviewCount: "127",
              bestRating: "5",
              worstRating: "1",
            },
          })}
        </script>

        {/* Place Schema - Processing Facility */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Place",
            name: "Worga Naturals Processing Facility",
            description:
              "State-of-the-art BRC A+ certified organic food processing facility with 125 kW solar system",
            address: {
              "@type": "PostalAddress",
              streetAddress: "No. 152/G, Meepavita, Udamapitigama",
              addressLocality: "Dompe",
              postalCode: "11680",
              addressCountry: "LK",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: "7.1234",
              longitude: "80.1234",
            },
            amenityFeature: [
              {
                "@type": "LocationFeatureSpecification",
                name: "BRC A+ Certified Facility",
              },
              {
                "@type": "LocationFeatureSpecification",
                name: "125 kW Solar Power System",
              },
              {
                "@type": "LocationFeatureSpecification",
                name: "In-House Quality Lab",
              },
              {
                "@type": "LocationFeatureSpecification",
                name: "90% Women Workforce",
              },
            ],
          })}
        </script>

        {/* CollectionPage Schema - Product Categories */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: "Organic Product Categories",
            description: "Premium organic tropical products from Sri Lanka",
            hasPart: [
              {
                "@type": "Product",
                name: "King Coconut Water",
                category: "Organic Beverages",
              },
              {
                "@type": "Product",
                name: "Dehydrated Fruits",
                category: "Organic Dried Fruits",
              },
              {
                "@type": "Product",
                name: "Jackfruit & Banana Blossom",
                category: "Vegan Alternatives",
              },
              {
                "@type": "Product",
                name: "Fruit Juice & Pulp",
                category: "Organic Ingredients",
              },
              {
                "@type": "Product",
                name: "Fruit Powder",
                category: "Organic Ingredients",
              },
              {
                "@type": "Product",
                name: "Organic Spices",
                category: "Spices & Seasonings",
              },
              {
                "@type": "Product",
                name: "Canned/Bottle Fruit",
                category: "Preserved Fruits",
              },
            ],
          })}
        </script>

        {/* Action Schema - Contact CTA */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Action",
            name: "Start Your Private Label Project",
            description:
              "Connect with us to launch your organic product line with custom formulations and packaging",
            target: {
              "@type": "EntryPoint",
              urlTemplate: "https://worganaturals.com/contact",
              actionPlatform: [
                "http://schema.org/DesktopWebPlatform",
                "http://schema.org/MobileWebPlatform",
              ],
            },
          })}
        </script>
      </Helmet>

      <div className="overflow-hidden">
        <Hero />
        <ExportProducts />
        <PrivateLabelSection />
        <ProcessesFacilities />
        <QualityTraceability />
        <CompanyIntro />
        <ProductReach />
      </div>
    </>
  );
};

export default Home;
